import { makeStyles } from "@material-ui/core";

const styles = makeStyles(() => ({
  status: {
    display: "flex",
    alignItems: "center",
  },
  statusIcon: {
    width: 16,
    height: 16,
    marginRight: 10,
  },
}));

export default styles;
